export default "__VITE_ASSET__CPFOXCwg__"